import { db } from "./db.js";
import { ref } from "vue";
import { getMember } from "./teams.js";

// ==================== CREATE ====================

function addPatent(firmId, data) {
  const ref = db.collection(`firms/${firmId}/patents`).doc(data.applId);
  return ref.set(data);
}

// Manually created patents use a caller-chosen ID (always prefixed with
// "NEW-" by the caller) instead of a Firestore auto-generated document ID.
function createManualPatent(firmId, data) {
  const ref = db.collection(`firms/${firmId}/patents`).doc(data.applId);
  return ref.set(data);
}

// ==================== READ ====================
// certain reads are against patent-views collection
async function getPatents(firmId) {
  const patents = ref([]);
  db.collection(`firms/${firmId}/patent-views`).onSnapshot((querySnapshot) => {
    patents.value = querySnapshot.docs.map((doc) => {
      return { id: doc.id, ...doc.data() };
    });
  });
  return patents;
}

async function getPatent(firmId, patentId) {
  return db.doc(`firms/${firmId}/patents/${patentId}`)
    .get()
    .then((patent) => {
      return patent.exists ? patent.data() : null;
    });
}

async function getPatentsOfUser(firmId, userId) {
  const patents = ref([]);
  const member = await getMember(firmId, userId);

  return new Promise((resolve, reject) => {
    const collectionRef = db.collection(`firms/${firmId}/patent-views`);
    let query;

    if (member && (member.role == "admin")) {
      query = collectionRef;
    } else {
      // member and client alike: only patents explicitly assigned to them
      // (uid in assigned[]). For clients this is how staff share portfolio items.
      query = collectionRef.where("assigned", "array-contains", userId);
    }

    const unsubscribe = query.onSnapshot((querySnapshot) => {
      patents.value = querySnapshot.docs.map((doc) => {
        return {
          id: doc.id,
          ...doc.data(),
        };
      });
      resolve({ patents, unsubscribe }); // Resolve with patents and unsubscribe function
    }, reject);
  });
}

async function getPatentsOfClient(firmId, clientId) {

  const patents = ref([]);
  await db.collection(`firms/${firmId}/patent-views`)
    .where("client", "==", clientId)
    .get().then((querySnapshot) => {
      patents.value = querySnapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }))
    });
  return patents;
}

// ==================== UPDATE ====================

async function updatePatent(firmId, patentId, data, transaction = null) {
  const patentRef = db.doc(`firms/${firmId}/patents/${patentId}`);
  if (transaction) {
    transaction.update(patentRef, data);
  } else {
    console.log("updafdsfsdf");
    await patentRef.update(data);
  }
}

// ==================== DELETE ====================

function deletePatent(firmId, patentId) {
  return db.doc(`firms/${firmId}/patent/${patentId}`).delete();
}

export {
  addPatent,
  getPatents,
  getPatent,
  getPatentsOfUser,
  updatePatent,
  deletePatent,
  getPatentsOfClient,
  createManualPatent,
};
